var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"WalletStatistics"},_vm._l((_vm.stats),function(indicator,index){return _c('div',{key:index,staticClass:"Grid-row"},[_c('div',{staticClass:"Grid-column-4"},[_vm._v(_vm._s(indicator.label)+":")]),_c('div',{staticClass:"Grid-column-4",domProps:{"innerHTML":_vm._s(indicator.value)}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }